import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Bounce } from 'react-activity';
import GetName from './GetName';

import {agent} from '../../../../services/api';
let apiAgent = new agent();

var agent_id = localStorage.getItem('id_agent');

export default class ListPastExam extends Component{
    state = {
        consultas: [],
        loading: false,
    }

    componentDidMount(){
        this.loadData();
    }

    // /agent/${agent_id}
    
    loadData = async () => {
        this.setState({loading: true})
        const request = await apiAgent.getAllAgentExams(agent_id,[{ header: 'status', value: 'Realizada' }]);
        console.log(request.data);
        this.setState({consultas: request.data});
        this.setState({loading: false})
    };


    render(){
        return(
            <>
                { this.state.consultas.map(exams =>(
                    <>
                        <NavLink to={{pathname:"/RI_ConsultasDetalhes/"+exams._id}}>
                            <button id="RI-Consulta" key={exams._id}><GetName user_id = {exams.user_id}/></button>
                        </NavLink>
                    </>
                ))
                }
                {this.state.loading === true ? <Bounce
                    size={30}
                    color="rgb(200,70,90"
                    speed={1}/> : null }
            </>
        );
    };
}


// Code original Hugo
/*
 <button onClick={ /*localStorage.setItem(exam_id, exams._id) this.SetData_LS(exams._id, exams.user_id, exams.professional_id) } id="RI-Consulta" key={exams.id}>
                                
 <GetName user_id = {exams.user_id}/>
 </button>

*/
